/**
 * @license lucide v0.577.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

const BugOff = [
  ["path", { d: "M12 20v-8" }],
  ["path", { d: "M12.656 7H14a4 4 0 0 1 4 4v1.344" }],
  ["path", { d: "M14.12 3.88 16 2" }],
  ["path", { d: "M17.123 17.123A6 6 0 0 1 6 14v-3a4 4 0 0 1 1.72-3.287" }],
  ["path", { d: "m2 2 20 20" }],
  ["path", { d: "M21 5a4 4 0 0 1-3.55 3.97" }],
  ["path", { d: "M22 13h-3.344" }],
  ["path", { d: "M3 21a4 4 0 0 1 3.81-4" }],
  ["path", { d: "M3 5a4 4 0 0 0 3.55 3.97" }],
  ["path", { d: "M6 13H2" }],
  ["path", { d: "m8 2 1.88 1.88" }],
  ["path", { d: "M9.712 4.06A3 3 0 0 1 15 6v1.13" }]
];

export { BugOff as default };
//# sourceMappingURL=bug-off.js.map
